import { createContext, use, useEffect, useState } from "react";
import { back, forward } from "./ContextHelper";
let sidebarContorls = {};
const Context = createContext();

export const ContextProvider = ({ children }) => {
  const [index, setIndex] = useState(0);
  const [modalView, setmodalView] = useState(false);
  const [picturePath, setPicturePath] = useState("");


  // sidebar
  const sidebarToggle = () => {
    const { sidebar, sidebarLinks, sidebarBtn, shade } = sidebarContorls;
    sidebarBtn.classList.toggle("open");
    shade.classList.toggle("shade-active");
    sidebar.classList.toggle("sidebar-active");
    Array.from(sidebarLinks).forEach(link =>
      link.classList.toggle("sidebar-link__animation")
    );
  };
  useEffect(() => {
    sidebarContorls.sidebar = document.querySelector(".sidebar");
    sidebarContorls.sidebarBtn = document.querySelector(".nav-btn");
    sidebarContorls.sidebarLinks = document.querySelectorAll(".sidebar-link");
    sidebarContorls.shade = document.querySelector(".shade");
  }, []);


  // modal
  const showModal = (e, list) => {
    setmodalView(modalView => !modalView);

    if (!modalView) {
      const picture = e.target;
      const newIndex = +picture.dataset.index;
      setPicturePath(picture.getAttribute("src"));
      setIndex(newIndex);
    } else {
      list[index].scrollIntoView({ inline: "start" });
    }
  };

  // const setRandomPictureOnStart = () => {
  //   if (img) {
  //     newIndex = Math.floor(Math.random() * 4).
  //     setIndex(newIndex)
  //     len = -500 * newIndex

  //     img.forEach(i => {
  //       i.style.transform = `translate(${len}px,0)`
  //       i.style.opacity = "0"
  //       img[newIndex].style.opacity = "1"
  //     })
  //   }


  // modal
  const toggleModal = (action, list) => {
    let newIndex;
    let distance;
    if (action === back) {
      newIndex = index - 1;
      if (newIndex < 0) return;
      distance = "-200";
    }

    if (action === forward) {
      newIndex = index + 1;
      if (newIndex === list.length) return;
      distance = "200";
    }

    setIndex(newIndex);

    const modalPicture = document.querySelector(".modal-picture");
    moveModalPicture(modalPicture, distance, 400, newIndex);
    toggleDescription(400);
  };


  const moveModalPicture = (modalPicture, coordinates, delay, newIndex) => {
    modalPicture.style.transform = `translateX(${coordinates}px)`;
    modalPicture.style.opacity = "0";

    setTimeout(() => {
      setPicturePath(
        document.querySelector(`.img-${newIndex}`).getAttribute("src")
      );
      modalPicture.style.opacity = "1";
      modalPicture.style.transform = `translateX(0)`;
    }, delay);
  };

  const toggleDescription = delay => {
    const descriptionText = document.querySelector(".modal-desc");
    descriptionText.style.opacity = "0";

    setTimeout(() => {
      descriptionText.style.opacity = "1";
    }, delay);
  };

  return (
    <Context
      value={{
        showModal,
        modalView,
        setmodalView,
        picturePath,
        setPicturePath,
        index,
        setIndex,
        sidebarToggle,
        toggleModal
      }}
    >
      {children}
    </Context>
  );
};
export const useGalleryContext = () => use(Context)
  ;
